import { createClaimRequest } from './helper';
export const getGenerativeAssessments = createClaimRequest({
    route: '/claim/generative/assessments',
    method: 'get',
    source: 'data',
});
